import { render, staticRenderFns } from "./MenuTags.vue?vue&type=template&id=c2288a20"
import script from "./MenuTags.vue?vue&type=script&lang=js"
export * from "./MenuTags.vue?vue&type=script&lang=js"
import style0 from "./MenuTags.vue?vue&type=style&index=0&id=c2288a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports